export interface StrategyCalculatorPanelProps {
  onClose: () => void;
  /** The event start date string (ISO or parseable). Used to anchor the X-axis. */
  eventDateStr?: string | null;
  /** Fired whenever the calculator's recommended strategy changes (due to preset changes). */
  onRecommendationChange?: (strategyId: string) => void;
}

export enum DemandPreset {
  Weak = 'weak',
  BelowAvg = 'belowAvg',
  Typical = 'typical',
  AboveAvg = 'aboveAvg',
  Hot = 'hot',
}

export enum SellThroughPreset {
  Weak = 'weak',
  BelowAvg = 'belowAvg',
  Typical = 'typical',
  AboveAvg = 'aboveAvg',
  Hot = 'hot',
}

export interface PresetOption<T extends string> {
  value: T;
  label: string;
}

/** Maps UI preset enums to Snowflake percentile keys */
export const DEMAND_TO_PERCENTILE: Record<DemandPreset, string> = {
  [DemandPreset.Weak]: 'p10',
  [DemandPreset.BelowAvg]: 'p25',
  [DemandPreset.Typical]: 'p50',
  [DemandPreset.AboveAvg]: 'p75',
  [DemandPreset.Hot]: 'p90',
};

export const SELL_THROUGH_TO_PERCENTILE: Record<SellThroughPreset, string> = {
  [SellThroughPreset.Weak]: 'p10',
  [SellThroughPreset.BelowAvg]: 'p25',
  [SellThroughPreset.Typical]: 'p50',
  [SellThroughPreset.AboveAvg]: 'p75',
  [SellThroughPreset.Hot]: 'p90',
};

export type ConfidenceLevel = 'high' | 'medium';

export interface StrategyRow {
  id: string;
  label: string;
  adCost: string;
  netRevenue: string;
  confidence: ConfidenceLevel;
  isRecommended?: boolean;
}
